import { render, staticRenderFns } from "./SportsTable.vue?vue&type=template&id=681d8856&scoped=true"
import script from "./SportsTable.vue?vue&type=script&lang=js"
export * from "./SportsTable.vue?vue&type=script&lang=js"
import style0 from "./SportsTable.vue?vue&type=style&index=0&id=681d8856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d8856",
  null
  
)

export default component.exports